import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtpActionsPopup } from './atp-actions-popup.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { AtpTitleModule } from '../atp-title/atp-title.module';

@NgModule({
  declarations: [
    AtpActionsPopup
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    AtpTitleModule
  ],
  exports: [
    AtpActionsPopup
  ]
})
export class AtpActionsPopupModule { }
